import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _cloneDeep from "lodash/cloneDeep";
import _get from "lodash/get";
import _omit from "lodash/omit";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isUnauthenticateAction } from "../utils/auth";
import { signin, signinWithOneTimeToken, register, authenticateWithGoogle, authenticateWithCorpIdp, authenticateWithApple, requestIdentity, preloadIdentity, setSecurityQuestion, signinWithRefreshToken, verifySmsCode, verifyCaptcha, setTUAuthentication, updateEmail, createPassword } from "../actions";
import { AuthProviders } from "../constants/internal";

var updateCurrentIdentity = function updateCurrentIdentity(state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var identity = payload.identity;
  var enableHeadersAndMeta = meta.enableHeadersAndMeta;

  if (enableHeadersAndMeta) {
    identity = payload.data.identity;
  }

  return _omit(identity, 'profiles');
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var payload = action.payload,
      meta = action.meta;

  if (isUnauthenticateAction(action)) {
    return {};
  }

  switch (action.type) {
    case signin.SUCCESS_TYPE:
    case signinWithOneTimeToken.SUCCESS_TYPE:
    case register.SUCCESS_TYPE:
    case authenticateWithGoogle.SUCCESS_TYPE:
    case authenticateWithApple.SUCCESS_TYPE:
    case authenticateWithCorpIdp.SUCCESS_TYPE:
    case signinWithRefreshToken.SUCCESS_TYPE:
    case requestIdentity.SUCCESS_TYPE:
      return updateCurrentIdentity(state, payload, meta);

    case preloadIdentity.getType():
      {
        var identity = _get(payload, 'IdentityStore.currentIdentity');

        return updateCurrentIdentity(state, {
          identity: identity
        });
      }

    case setSecurityQuestion.SUCCESS_TYPE:
      {
        var newState = _cloneDeep(state);

        newState.roles = newState.roles || [];
        newState.roles.push('nerdwallet/has_security_challenge');
        return newState;
      }

    case verifySmsCode.SUCCESS_TYPE:
      {
        var _newState = _cloneDeep(state);

        _newState.roles = _newState.roles || [];

        _newState.roles.push('nerdwallet/has_verified_phone');

        return _newState;
      }

    case verifyCaptcha.SUCCESS_TYPE:
      {
        var _newState2 = _cloneDeep(state);

        _newState2.roles = _newState2.roles || [];

        _newState2.roles.push('nerdwallet/has_passed_captcha');

        return _newState2;
      }

    case setTUAuthentication.SUCCESS_TYPE:
      {
        var _newState3 = _cloneDeep(state);

        _newState3.roles = _newState3.roles || [];

        _newState3.roles.push('nerdwallet/has_activated_transunion');

        return _newState3;
      }

    case createPassword.SUCCESS_TYPE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          auth_providers: [].concat(_toConsumableArray(_get(state, 'auth_providers', [])), [AuthProviders.NERDWALLET]),
          has_password: true
        });
      }

    case updateEmail.SUCCESS_TYPE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          email: _get(meta, 'newEmail'),
          // changing email invalidates previous email verification
          verified_at: null
        });
      }

    default:
      return state;
  }
});